
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 58 58"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"currentColor","fill-rule":"evenodd"}},[_c('circle',{attrs:{"cx":"29","cy":"29","r":"29","fill-opacity":".12"}}),_c('g',{attrs:{"fill-rule":"nonzero"}},[_c('path',{attrs:{"d":"M21.728 14h-3.94a2.731 2.731 0 00-2.73 2.726v25.347a2.731 2.731 0 002.73 2.726h3.94a2.731 2.731 0 002.73-2.726V16.726A2.731 2.731 0 0021.729 14zm19.96 2.906H26.454v24.987h15.234a3.37 3.37 0 003.37-3.364V20.27a3.37 3.37 0 00-3.37-3.363zM31.102 38.375H29.5a.997.997 0 110-1.993h1.602a.997.997 0 110 1.993zm0-3.185H29.5a.997.997 0 110-1.993h1.602a.997.997 0 110 1.993zm0-3.211H29.5a.997.997 0 110-1.993h1.602a.997.997 0 110 1.993zm5.455 6.387h-1.602a.997.997 0 110-1.992h1.602a.997.997 0 110 1.992zm0-3.185h-1.602a.997.997 0 110-1.992h1.602a.997.997 0 110 1.992zm0-3.211h-1.602a.997.997 0 110-1.992h1.602a.997.997 0 110 1.992zm5.455 6.396H40.41a.997.997 0 110-1.992h1.602a.997.997 0 110 1.992zm0-3.185H40.41a.997.997 0 110-1.992h1.602a.997.997 0 110 1.992zm0-3.211H40.41a.997.997 0 110-1.992h1.602a.997.997 0 110 1.992zm.997-5.06a1.58 1.58 0 01-1.579 1.576H30.081a1.58 1.58 0 01-1.579-1.576v-4.58c0-.87.709-1.578 1.58-1.578H41.43c.871 0 1.58.708 1.58 1.577v4.58z"}}),_c('path',{attrs:{"d":"M30.498 22.745h10.516v3.749H30.498zM13.063 17.17A3.369 3.369 0 0011 20.27v18.26c0 1.392.852 2.59 2.063 3.1V17.17z"}})])])])
          )
        }
      }
    